import Hotjar from "@hotjar/browser";

const siteId = process.env.REACT_APP_HOTJAR_ID;
const hotjarVersion = process.env.REACT_APP_HOTJAR_VERSION || "6";

const env = process.env.REACT_APP_ENV;

if (siteId && hotjarVersion && env === "production") {
  try {
    console.log("Initializing Hotjar");
    Hotjar.init(Number(siteId), Number(hotjarVersion));
  } catch (error) {
    console.error("Hotjar initialization failed:", error);
  }
}
